import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import RuntimeFieldGroup from './ssRuntimeFieldGroup';
import ControlChangesIcon from '../../components/ControlChangesIcon';
import { FCM_CONTAINER_STYLES } from '../../constants/runtime.constants';

const useStyles = makeStyles(FCM_CONTAINER_STYLES);

const SSFieldGroup = ({ isControlHiddenFCM, isControlAddedFCM, isControlChangedFCM, ...props }) => {
  const classes = useStyles({ isControlAddedFCM });

  if (isControlAddedFCM || isControlChangedFCM) {
    return (
      <div
        className={classes.changesModeWrapper}
        style={{ width: isControlAddedFCM ? 586 : 618 }}
        data-ss-id={props.id}
      >
        <div
          className={classNames(classes.control, isControlHiddenFCM ? classes.hiddenControl : '')}
          data-hidden-fcm={isControlHiddenFCM}
        >
          <RuntimeFieldGroup {...props} />
        </div>
        {isControlChangedFCM && (
          <div className={classes.changesIcon}>
            <ControlChangesIcon id={props.id} />
          </div>
        )}
      </div>
    );
  }

  if (isControlHiddenFCM) {
    return (
      <div className={classes.hiddenControl} data-hidden-fcm="true">
        <RuntimeFieldGroup {...props} />
      </div>
    );
  }

  return <RuntimeFieldGroup {...props} />;
};

export default SSFieldGroup;
